import BookingsAdapter from './base';

export default class Allocation extends BookingsAdapter {
  modelNamePlural = 'allocations';
}
